import React from 'react';
import { Box } from '@mui/material';

import ViewOptions from '../../dialogs/ViewOptions';
import { useIsClientInMobileMode } from '../../hooks';
import AddItemButton from '../buttons/AddItemButton';
import { AddPlatesButton } from '../buttons/AddPlatesButton';
import { AnalysisHistoryButton } from '../buttons/AnalysisHistoryButton';
import AnalyzeButton from '../buttons/AnalyzeButton';
import { DownloadButton } from '../buttons/DownloadButton';
import { EditTrussButton } from '../buttons/EditTrussButtton';
import FocusButton from '../buttons/FocusButton';
import { Layout3DCameraButton } from '../buttons/Layout3DCameraButton';
import { LayoutAutomaticDimensioningButtons } from '../buttons/LayoutAutomaticDimensioningButtons';
import { NotificationsButton } from '../buttons/NotificationsButton';
import { OptimizationButton } from '../buttons/OptimizationButton';
import ResetViewButton from '../buttons/ResetViewButton';
import { SnappingSettingsButton } from '../buttons/SnappingSettingsButton';
import UserDimensionsButton from '../buttons/UserDimensionsButton';
import { FULL_WIDTH_TOOLBAR_STYLING } from './StandardToolbar';
import { ToolbarBase } from './ToolbarBase';
import { ToolbarVerticalDivider } from './ToolbarVerticalDivider';

export function MobileToolbar() {
  const visible = useIsClientInMobileMode();
  if (!visible) return null;

  // When editing this toolbar, please consider whether `StandardToolbar` should be updated as well.

  return (
    <ToolbarBase wrap orientation="horizontal" elevation={1} sx={FULL_WIDTH_TOOLBAR_STYLING}>
      <Layout3DCameraButton />
      <ResetViewButton />
      <FocusButton />

      <ToolbarVerticalDivider />

      <LayoutAutomaticDimensioningButtons />
      <UserDimensionsButton />
      <ViewOptions />
      <ToolbarVerticalDivider />
      <SnappingSettingsButton />

      <Box sx={{ flexGrow: 1 }} />

      <AddItemButton condensed />
      <AnalyzeButton condensed />
      <AddPlatesButton condensed />
      <DownloadButton condensed />
      <ToolbarVerticalDivider />
      <AnalysisHistoryButton />
      <OptimizationButton />
      <NotificationsButton />

      <EditTrussButton />
    </ToolbarBase>
  );
}
